const tabTriggers = document.querySelectorAll('.js-tab-trigger'),
    tabContent = document.querySelectorAll('.js-tab-content');

function changeTab (e, profile) {
    e.preventDefault();

    // Change .active nav item
    [...tabTriggers].forEach(el => {
        if (el === e.target) {
            el.classList.add('active');
        } else {
            if (el === e.target.parentElement) {
                e.target.parentElement.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        }
    });

    // Change .active tab
    [...tabContent].forEach(el => {
        if (
            'tab' in el.dataset && 
            (el.dataset.tab === e.target.dataset.target || el.dataset.tab === e.target.parentElement.dataset.target)
        ) {
            el.classList.add('active');
        } else {
            el.classList.remove('active');
        }
    });
}

[...tabTriggers].forEach(el => {
    el.addEventListener('click', e => {
        changeTab(e, el);
    });
});
